export const USER_PERSONALIZATION_DATA = 'USER_PERSONALIZATION_DATA';
